var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#3AB03E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65306 9.43819C9.87665 9.33105 10.0655 9.163 10.1978 8.95334C10.3302 8.74368 10.4007 8.50093 10.4012 8.253C10.4012 7.52513 9.80381 6.93506 9.06806 6.93506C8.33119 6.93506 7.73325 7.52513 7.73325 8.253C7.73386 8.50099 7.80451 8.74376 7.93707 8.95334C8.06963 9.16293 8.2587 9.3308 8.4825 9.43762V11.0655H9.65306V9.43819ZM9.06806 13.2188C6.71344 13.2188 4.79869 11.3265 4.79869 9C4.79869 6.6735 6.71344 4.78125 9.06806 4.78125C10.989 4.78125 12.6174 6.04125 13.1518 7.76925H14.6233C14.0552 5.25488 11.7838 3.375 9.0675 3.375C5.92369 3.375 3.375 5.89331 3.375 9C3.375 12.1067 5.92369 14.625 9.0675 14.625C11.7838 14.625 14.0552 12.7451 14.6233 10.2308H13.1512C12.6169 11.9587 10.989 13.2188 9.06806 13.2188Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvc);
export default __webpack_public_path__ + "static/media/cvc.f35f6d6af4e3f9fe1eb0f93cc9afd532.svg";
export { ForwardRef as ReactComponent };